function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from "react";
import { usePopper } from "react-popper";
import { NotificationFeed } from "../NotificationFeed";
import useComponentVisible from "../../hooks/useComponentVisible";
import { useKnockFeed } from "../KnockFeedProvider";

var defaultOnOpen = _ref => {
  var {
    store,
    feedClient
  } = _ref;

  if (store.metadata.unseen_count > 0) {
    feedClient.markAllAsSeen();
  }
};

export var NotificationFeedPopover = _ref2 => {
  var {
    isVisible,
    onOpen = defaultOnOpen,
    onClose,
    buttonRef,
    closeOnClickOutside = true,
    placement = "bottom-end"
  } = _ref2,
      feedProps = _objectWithoutProperties(_ref2, ["isVisible", "onOpen", "onClose", "buttonRef", "closeOnClickOutside", "placement"]);

  var {
    colorMode,
    feedClient,
    useFeedStore
  } = useKnockFeed();
  var store = useFeedStore();
  var {
    ref: popperRef
  } = useComponentVisible(isVisible, onClose, {
    closeOnClickOutside
  });
  var {
    styles,
    attributes
  } = usePopper(buttonRef.current, popperRef.current, {
    strategy: "fixed",
    placement,
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, 8]
      }
    }]
  });
  useEffect(() => {
    // Whenever the feed is opened, we want to invoke the `onOpen` callback
    // function to handle any side effects.
    if (isVisible && onOpen) {
      onOpen({
        store,
        feedClient
      });
    }
  }, [isVisible]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "rnf-notification-feed-popover rnf-notification-feed-popover--".concat(colorMode),
    style: _objectSpread(_objectSpread({}, styles.popper), {}, {
      visibility: isVisible ? "visible" : "hidden"
    }),
    ref: popperRef
  }, attributes.popper, {
    role: "dialog",
    tabIndex: -1
  }), /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-feed-popover__inner"
  }, /*#__PURE__*/React.createElement(NotificationFeed, feedProps)));
};
//# sourceMappingURL=NotificationFeedPopover.js.map